import "./FooterStyles.css";
const Footer = () => {
    return (
        <div className="footer">
            <div className="top">
                <div>
                    <h1>Quick Recipe</h1>
                    <p>Start a day with a healthy meal.</p>

                </div>
                <div>
                    <i className="fa-brands fa-instagram-square"></i>
                    
                    <i className="fa-brands fa-twitter-square"></i>
                    
                    <i className="fa-brands fa-facebook-square"></i>
                </div>
            </div>
        </div>

    )
}
export default Footer;